import React from "react";
import { NavLink } from "react-router";
import styled from "styled-components";

const NavList = styled.ul`
  margin: ${({ theme }) => theme.space[2]};
  display: flex;
  background-color: ${({ theme }) => theme.colors.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 3px;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-inline-end: 20%;
    margin-inline-start: 20%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    margin-inline-end: 30%;
    margin-inline-start: 30%;
  }
`;

const NavItem = styled.li`
  flex: 1;
  &:not(:last-child) {
    border-right: 2px solid white;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  padding: ${({ theme }) => theme.space[2]};
  color: white;
  font-family: ${({ theme }) => theme.fonts.base};
  font-weight: 700;
  text-decoration: none;
  text-align: center;

  &.active {
    background-color: white;
    color: ${({ theme }) => theme.colors.black};
  }
`;

interface IProps {
  defaultEntry?: number;
  leagueId: number;
  eventId: number;
}

const H2HNav: React.FC<IProps> = ({ eventId, leagueId, defaultEntry }) => {
  const defaultEntryParam = defaultEntry ? `default_entry=${defaultEntry}` : "";
  const links = [
    {
      href: `/leagues/${leagueId}/matches/h`,
      qs: `?event=${eventId}` + (defaultEntryParam && `&${defaultEntryParam}`),
      text: "Matches",
    },
    {
      href: `/leagues/${leagueId}/standings/h`,
      qs: defaultEntryParam && `?${defaultEntryParam}`,
      text: "Standings",
    },
  ];
  return (
    <nav>
      <NavList>
        {links.map((l) => (
          <NavItem key={l.href}>
            <StyledNavLink to={`${l.href}${l.qs}`} end>
              {l.text}
            </StyledNavLink>
          </NavItem>
        ))}
      </NavList>
    </nav>
  );
};

export default H2HNav;
